import { initDB, getSetting, setSetting } from '../lib/db/indexeddb.js';

const LANG_KEY = 'ytcs:lang';
const LS_LANG = 'ytcs:lang';

export function getLanguageSnapshotSync() {
  return localStorage.getItem(LS_LANG) || null;
}

export async function loadLanguageSetting() {
  const db = await initDB();
  const lang = await getSetting(db, LANG_KEY);
  const value = lang?.value || null;
  if (value) localStorage.setItem(LS_LANG, value);
  return value;
}

export async function saveLanguageSetting(localeCodeOrNull) {
  const db = await initDB();
  const value = localeCodeOrNull ? String(localeCodeOrNull).trim() : null;
  await setSetting(db, LANG_KEY, value);
  if (value) localStorage.setItem(LS_LANG, value);
  else localStorage.removeItem(LS_LANG);
  return value;
}
